import {BASE_PATH} from "../../../../custom/axios/config/Url";
import {DG_axios} from "../../../../custom/axios";

const baseURL = `${BASE_PATH}/dogoo/job-position-rest/v2.0/job-titles`

export async function getJobTitles(filter, page, pageSize, search, sort , status) {
    const response = await DG_axios.get(baseURL + `?status=${status}`,
        {
            params: {
                filter,
                page,
                pageSize,
                search,
                sort
            }
        })
    return response?.data || []
}

